import type { UrlQuery } from './UrlQuery'

/**
 * Query parameter names that represent actual search filters.
 * Derived from UrlQuery interface keys, excluding internal-only params (fetch_mode).
 * Used to distinguish search filters from tracking params (gclid, utm_*, etc.)
 * when deciding whether to show/hide SEO content.
 */
export const SEARCH_FILTER_PARAMS: ReadonlyArray<keyof UrlQuery> = [
  'arrive',
  'depart',
  'nights',
  'adults',
  'child_ages',
  'children',
  'lat',
  'lng',
  'within',
  'bounds',
  'min_price',
  'max_price',
  'hierarchyPath',
  'type',
  'facet',
  'page',
  'sort',
  'limit',
  'q',
  'placename',
] as const

const searchFilterSet = new Set<string>(SEARCH_FILTER_PARAMS)

/**
 * Returns true if the query contains any search filter parameters.
 * Ignores tracking params (gclid, utm_*, fbclid, etc.) and unknown params.
 */
export function hasSearchFilterParams(query: Record<string, unknown>): boolean {
  return Object.keys(query).some((key) => searchFilterSet.has(key))
}
